import React from 'react';
import usePlayersContext from '@playerHooks/usePlayersContext';
import classNames from 'classnames';
import useEpisodePlayersContext from '@mainHooks/useEpisodePlayersContext';

const DescriptionButton = () => {
    const { showDescription, setShowDescription, episodeIndex } = usePlayersContext();
    const { data } = useEpisodePlayersContext();
    const { episodeDescription } = data.episodes[episodeIndex];
    const popupDescription = () => {
        setShowDescription(!showDescription);
    };

    const btnClass = classNames('player-app__btn', 'episode-player-description', {
        'episode-player-active': showDescription,
    });

    return (
        episodeDescription && (
            <button onClick={popupDescription} className={btnClass} aria-label="Description">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.33333 5.33333H7M4.33333 7.66667H9M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 7.7981 1.15582 8.5598 1.43871 9.25634C1.49285 9.38965 1.51992 9.45631 1.532 9.51019C1.54381 9.56289 1.54813 9.6019 1.54814 9.65591C1.54814 9.71113 1.53812 9.77128 1.51807 9.89157L1.12275 12.2635C1.08135 12.5119 1.06065 12.6361 1.09917 12.7259C1.13289 12.8045 1.19552 12.8671 1.27412 12.9008C1.36393 12.9393 1.48812 12.9186 1.73651 12.8772L4.10843 12.4819C4.22872 12.4619 4.28887 12.4519 4.34409 12.4519C4.3981 12.4519 4.43711 12.4562 4.48981 12.468C4.54369 12.4801 4.61035 12.5072 4.74366 12.5613C5.4402 12.8442 6.2019 13 7 13Z" stroke="#28043C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </button>
        )
    );
};

export default DescriptionButton;
